import { defineStore } from 'pinia'

export const useDetailStore = defineStore('detail', () => {
  const quantity = ref(1)
  const variant = ref(null)
  return { quantity, variation: variant }
})
